export const sizeTitlesFactory = (intl) => {
    const { $t } = intl;
    return [
        {
            value: 'sm',
            text: $t({
                id: 'Blocks.Container.SizeTitles.Small',
                defaultMessage: 'Small (1 columns)',
            }),
        },
        {
            value: 'md',
            text: $t({
                id: 'Blocks.Container.SizeTitles.Medium',
                defaultMessage: 'Medium (2 columns)',
            }),
        },
        {
            value: 'lg',
            text: $t({
                id: 'Blocks.Container.SizeTitles.Large',
                defaultMessage: 'Large (3 columns)',
            }),
        },
        {
            value: 'xl',
            text: $t({
                id: 'Blocks.Container.SizeTitles.ExtraLarge',
                defaultMessage: 'Extra large (4 columns)',
            }),
        },
        {
            value: 'full',
            text: $t({
                id: 'Blocks.Container.SizeTitles.FullWidth',
                defaultMessage: 'Full width',
            }),
        },
    ];
};
export const directionTitlesFactory = (intl) => [
    {
        value: 'vertical',
        text: intl.$t({
            id: 'Blocks.Container.DirectionTitles.Vertical',
            defaultMessage: 'Vertical (Row)',
        }),
    },
    {
        value: 'grid',
        text: intl.$t({
            id: 'Blocks.Container.DirectionTitles.Horizontal',
            defaultMessage: 'Horizontal (Grid)',
        }),
    },
];
export const paddingTitlesFactory = (intl) => {
    const { $t } = intl;
    return [
        {
            value: 'none',
            text: $t({ id: 'Generics.None', defaultMessage: 'None' }),
        },
        {
            value: 'xs',
            text: $t({ id: 'Generics.ExtraSmall', defaultMessage: 'Extra small' }),
        },
        {
            value: 'sm',
            text: $t({ id: 'Generics.Small', defaultMessage: 'Small' }),
        },
        {
            value: 'md',
            text: $t({ id: 'Generics.Medium', defaultMessage: 'Medium' }),
        },
        {
            value: 'lg',
            text: $t({ id: 'Generics.Large', defaultMessage: 'Large' }),
        },
        {
            value: 'xl',
            text: $t({ id: 'Generics.ExtraLarge', defaultMessage: 'Extra large' }),
        },
    ];
};
//# sourceMappingURL=constants.js.map